import { Badge } from '@crossnokaye/ux-common/ckds';

interface SequenceActivityPillProps {
  /** Whether this sequence is currently active */
  isActive: boolean;
}

/**
 * Displays the active/inactive status of a sequence as a badge pill.
 * Used in sequencer section headers to indicate which sequence is currently running.
 *
 * @example
 * // Active sequence
 * <SequenceActivityPill isActive={true} />
 *
 * @example
 * // Inactive sequence
 * <SequenceActivityPill isActive={false} />
 */
export const SequenceActivityPill = ({ isActive }: SequenceActivityPillProps) => {
  return (
    <div className="flex items-center space-x-2">
      {isActive ? (
        <Badge variant={'brand'}>Active</Badge>
      ) : (
        <Badge variant={'default'}>Not Active</Badge>
      )}
    </div>
  );
};
